<template>
  <div class="c-dropdown--profile" >
    <nav class="c-dropdown--profile__menu">
      <slot></slot>
    </nav>
  </div>
</template>

<script>
/**
 * This is similar to the regular dropdown, but needs th
 */
export default {
  name: "DropdownProfile"
};
</script>

<style scoped lang="scss">
.c-dropdown--profile {
  position: relative;
  top: 10px;

  &:before {
    content: "";
    position: absolute;
    border: 10px solid transparent;
    border-bottom-color: $colour-nhs-white;
    top: -20px;
    z-index: 10;
    right: 15px;

    @media screen and (min-width: 1151px) {
      right: 60px;
    }
  }

  &__menu {
    position: absolute;
    max-width: 100vw;
    width: 400px;
    right: -16px;
    background: $colour-nhs-white;
    @media (min-width: 768px) {
      border-radius: 6px;
    }
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.19);
    overflow: hidden;

    @media screen and (min-width: 1151px) {
      right: 0;
    }

    ul,
    li {
      padding: 0;
      margin: 0;
    }
    li {
      padding: 20px;
      border-bottom: 1px solid $colour-nhs-pale-grey;
    }

    a {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>